import { render, staticRenderFns } from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=template&id=bf26328a&scoped=true"
import script from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnStrutturaPresidioComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf26328a",
  null
  
)

export default component.exports